"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=solana-nft-collection-contract-names.js.map